<style lang="scss" scoped src="./index.scss">
// .app-flex {
//     flex-wrap: wrap !important;
// }
</style>
<style lang="scss">
.app-tabs__popper-letter {
  border-radius: 50%;
  font-size: 20px;
  height: 36px;
  line-height: 36px;
  padding: 0;
  text-align: center;
  width: 36px;

  &.el-tooltip__popper[x-placement^="top"],
  &.el-tooltip__popper[x-placement^="bottom"] {
    background: rgba(81, 81, 82, 0.7);
  }

  &.el-tooltip__popper[x-placement^="top"] .popper__arrow {
    top: 35px;

    &::after {
      border-top-color: rgba(81, 81, 82, 0.7);
    }
  }

  &.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
    top: -5px;

    &::after {
      border-bottom-color: rgba(81, 81, 82, 0.7);
    }
  }

  .popper__arrow {
    border-color: #fff;
    // left: 7px !important;
    color: rgba(81, 81, 82, 0.7);
  }
}
</style>
<template>
  <ul class="app-tabs app-flex app-flex-wrap">
    <template v-for="(item, i) in tabs">
      <el-tooltip
        :key="i"
        :disabled="item.type !== 'letter' || item.type !== 'label'"
        :open-delay="300"
        popper-class="app-tabs__popper-letter"
        effect="dark"
        :content="item.name"
        placement="top"
      >
        <li
          v-if="type === 'letter'"
          class="app-tabs__item"
          :class="{
            active: currentId === item.id,
            'app-tabs__item-letter': item.type === 'letter',
          }"
          @click="changeTab(item)"
        >
          {{ item.name }}
        </li>
        <li
          v-if="type === 'label'"
          class="app-tabs__itemlabel"
          :class="{
            active: currentId === item.id,
            'app-tabs__itemlabel-label': item.type === 'label',
          }"
          @click="changeTab(item)"
        >
          {{ item.name }}
          <div class="label-border"></div>
        </li>
      </el-tooltip>
    </template>
  </ul>
</template>
<script>
export default {
  name: "appTabs",
  model: {
    prop: "currentId",
    event: "change",
  },
  props: {
    tabs: {
      type: Array,
    },
    change: {
      type: Function,
    },
    currentId: {
      type: Number,
      default() {
        return this.tabs[0].id || 0;
      },
    },
    type: {
      type: String,
      default: "label",
    },
  },
  methods: {
    changeTab(item) {
      this.$emit("change", item.id);
      this.change(item);
    },
  },
};
</script>
